import Alert from 'react-s-alert';
import base64 from 'base-64';
import utf8 from 'utf8';
import history from '../history';
import moment from 'moment';
import React from 'react';
import { loginActionTypes } from '../modules/logins/constants/ApiConstants';

// export const API_URL = 'http://localhost:51269';
// export const API_URL = 'https://10.138.0.154:5001'; // live url
// export const API_URL = 'https://api.theralytics.net'; // live url
// export const API_URL = 'https://stagingapi.theralytics.net'; //live staging url
// export const API_URL = 'https://stagingqaapi.theralytics.net'; //live staging url
// export const API_URL = 'https://developmentapi.theralytics.net'; //live development url
// export const API_URL = 'http://104.238.100.164:5001'; //  staging url
// export const API_URL = 'http://104.238.100.164:5006'; // merging url

export const ENVIRONMENTS = {
  // New QA environments using *.qa.theralytics.net
  DEV: 'development.qa.theralytics.net',
  RELEASE: 'release.qa.theralytics.net',
  QA1: 'qa1.qa.theralytics.net',  
  QA2: 'qa2.qa.theralytics.net',
  QA3: 'qa3.qa.theralytics.net',
  QA4: 'qa4.qa.theralytics.net',
  STAGING: 'staging.qa.theralytics.net',
  
  // Production environment 
  PRODUCTION: 'theralytics.net',
  
  // Legacy environments
  LEGACY_STAGING: 'staging.theralytics.net', 
  LEGACY_DEVELOPMENT: 'development.theralytics.net',
  LEGACY_STAGINGQA: 'stagingqa.theralytics.net'
};

export const API_URL = process.env.REACT_APP_API_URL;

export const IS_REPORT_ORGANISED = 'YES';
export const REPORT_URL = process.env.REACT_APP_REPORT_URL;
// export const CLOUDREPORT_URL = 'https://cloudreports.theralytics.net/Report.aspx';

const REQUEST = 'REQUEST';
const SUCCESS = 'SUCCESS';
const FAILURE = 'FAILURE';

export const BEHAVIOR_BLOSSOMS = 'BEHAVIORBLOSSOMS';
// export const BEHAVIOR_BLOSSOMS = 'VIP';
export const NOVA = 'NOVA';
export const EBS = 'EBS';
export const NE_ABA = 'NE-ABA';
export const BESTABA = 'BESTABA';
export const DEMO = 'DEMO1234';
export const AIP = 'AIP';
export const SWANCONSULTINGINC = 'SWANCONSULTINGINC';
export const ART = 'ART';
export const VIP = 'VIP';
export const VILLAGELEARNING = 'VILLAGELEARNING';
export const CBG = 'CBG';
export const CWABA = 'CWABA';
export const BUILDABLOCKTHERAPY = 'BUILDABLOCKTHERAPY';
export const ADAMANTSERVICES = 'ADAMANTSERVICES';
export const CBF = 'CBF';
export const EARLYBIRDSABA = 'EARLYBIRDSABA';
export const POSITIVEBEHAVIORSTEPS = 'POSITIVEBEHAVIORSTEPS';
export const UPLUS = 'UPLUS';
export const BRIDGES = 'BRIDGES';
export const CAS = 'CAS';
export const PACE = 'PACE';
export const LINKTOLEARN = 'LINKTOLEARN';
export const VICTORIOUSLEARNING = 'VICTORIOUSLEARNING';
export const BALLSBRIDGEBCS = 'BALLSBRIDGEBCS';
export const ALLIUM = 'ALLIUM';
export const GOLDENFLOWERNW = 'GOLDENFLOWERNW';
export const SEEDLINGSABA = 'SEEDLINGSABA';
export const BLUEBIRDBEHAVIORAL = 'BLUEBIRDBEHAVIORAL';
export const HELPINGHANDS = 'HELPINGHANDS';
export const LITTLELEMONS = 'LITTLELEMONS';
export const ABAORLANDO = 'ABAORLANDO';
export const STAR = 'STAR';
export const TIIBA = 'TIIBA';
export const AMEGO = 'AMEGO';
export const IAT = 'IAT';
export const UPSTATEABA = 'UPSTATEABA';
export const EBP = 'EBP';
export const CAMINOABA = 'CAMINOABA';
export const KNOWBOUNDARIES = 'KNOWBOUNDARIES';
export const POPPYSPROMISE = 'POPPYSPROMISE';
export const CWO = 'CWO';
export const STEPUPFAMILYSERVICES = 'STEPUPFAMILYSERVICES';
export const SOAR = 'SOAR';
export const ABCSPECTRUM = 'ABCSPECTRUM';
export const GROWBEHAVIOR = 'GROWBEHAVIOR';
export const JOYSCAPE = 'JOYSCAPE';
export const STEPUPOUTPATIENT = 'STEPUPOUTPATIENT';
export const HYPERIONCENTER = 'HYPERIONCENTER';
export const FUTURES = 'FUTURES';
export const AMEGOFL = 'AMEGOFL';
export const TFABA = 'TFABA';
export const ARROWS = 'ARROWS';
export const ADASTRA = 'ADASTRA';
export const STAGINGQA = 'STAGINGQA';
export const SBS = 'SBS';
export const TEST = 'TEST';
export const CONVERGENCY = 'CONVERGENCY';

const SystemIpAddress = new Promise((r) => {
  var w = window, a = new (w.RTCPeerConnection || w.mozRTCPeerConnection || w.webkitRTCPeerConnection)({ iceServers: [] }), b = () => { }; a.createDataChannel(''); a.createOffer((c) => a.setLocalDescription(c, b, b), b); a.onicecandidate = (c) => {
    try {
      c.candidate.candidate.match(/([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g).forEach(r);
    } catch (e) { }
  };
});

export function isEmptyObject(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key))
      return false;
  }
  return true;
}

export function displayCustomError(fieldName, errorList) { //  Display error message for already exist field
  return errorList && errorList.length && errorList.some((err) => {
    return (err.statusCode === 409 && err.data.toUpperCase() === fieldName);
  }) ? <p>{errorList.map((err) => {
      if (err.statusCode === 409 && err.data.toUpperCase() === fieldName) {
        return `${err.message}`;
      }
      return `${err.message}`;
    })}</p> : undefined;
};

export default function GlobalVariables() {
  constructor();
  this.PageSize = 10;
  this.IpAddress = 1;
  this.CurrentLocationId = 0;
  this.IntervalDuration = 5.00; // for Data collection record interval and Duration
  // this.AccessToken = localStorage.getItem('access_token');
  // this.errorMessage = 'Oops, something went wrong, please try later.';
};

SystemIpAddress.then(function(value) {
  GlobalVariables.IpAddress = value;
}).catch((e) => console.error(e));

export function createRequestActionTypes(base) {
  return [REQUEST, SUCCESS, FAILURE].reduce((requestTypes, type) => {
    requestTypes[type] = `${base}_${type}`;
    return requestTypes;
  }, {});
}

export function calculateTimeZone(dateInput) {
  var dateObject = dateInput || new Date(),
    dateString = dateObject + '',
    tzAbbr = (
      // Works for the majority of modern browsers
      dateString.match(/\(([^\)]+)\)$/) ||
      // IE outputs date strings in a different format:
      dateString.match(/([A-Z]+) [\d]{4}$/)
    );

  if (tzAbbr) {
    // Old Firefox uses the long timezone name (e.g., "Central
    // Daylight Time" instead of "CDT")
    tzAbbr = tzAbbr[1];
  }

  // Uncomment these lines to return a GMT offset for browsers
  // that don't include the user's zone abbreviation (e.g.,
  // "GMT-0500".) I prefer to have `null` in this case, but
  // you may not!
  // First seen on: http://stackoverflow.com/a/12496442
  // if (!tzAbbr && /(GMT\W*\d{4})/.test(dateString)) {
  //  return RegExp.$1;
  // }

  return tzAbbr;
};


// export function calculateTimeZone() {
//   let TZ = /\((.*)\)/.exec(new Date().toString());
//   let TimeZone = '';
//   if (TZ.length > 0)
//     TimeZone = TZ[1];
//   return TimeZone;
// };


export const jsonApiHeaderBusinessName = (accessToken, ContentType) => {
  return ({
    'Content-Type': ContentType ? ContentType : 'application/vnd.api+json',
    // 'Authorization': accessToken ? `Bearer ${accessToken}` : '',
    // 'Timezone': calculateTimeZone(),
    'Timezone': filterNonISO8859OrLimitToASCII(calculateTimeZone()), // converting the non-iso string with iso/empty string
    'IPAddress': GlobalVariables.IpAddress,
    'LocationID': GlobalVariables.CurrentLocationId ? GlobalVariables.CurrentLocationId : 0,
    'Offset': moment().utcOffset(),
  });
};

export function filterNonISO8859OrLimitToASCII(input) {
  if (typeof input === 'string') {
    // Replace or remove any non-ISO-8859-1 characters from the input.
    return input.replace(/[^\x00-\x7F]/g, '');
  } else {
    return '';
  }
}

export const jsonApiHeader = (accessToken, ContentType) => {
  return ({
    'Content-Type': ContentType ? ContentType : 'application/vnd.api+json',
    'Authorization': accessToken ? `Bearer ${accessToken}` : '',
    // 'Authorization': GlobalVariables.AccessToken ? `Bearer ${GlobalVariables.AccessToken}` : accessToken ? `Bearer ${accessToken}` : '',
    // 'Timezone': calculateTimeZone(),
    'Timezone': filterNonISO8859OrLimitToASCII(calculateTimeZone()), // converting the non-iso string with iso/empty string
    'IPAddress': GlobalVariables.IpAddress,
    'LocationID': GlobalVariables.CurrentLocationId ? GlobalVariables.CurrentLocationId : 0,
    'Offset': moment().utcOffset(),
  });
};

export function actionCreator(actionType, data) {
  // if(actionType.toString().indexOf("CHECK_BUSINESS_NAME_SUCCESS") === -1 && actionType.toString().indexOf("REQUEST") === -1 && data && data.access_token)
  // {
  //   GlobalVariables.AccessToken = data.access_token;
  //   localStorage.setItem('access_token', data.access_token);
  // }
  return {
    type: actionType,
    payload: data,
  };
}

export function checkHttpStatus(response) {
  if (response.status >= 200 && response.status < 204) {
    return response.json();
  } else if (response.status === 204) {
    return true;
  } else if (response.status >= 400 && response.status < 500) {
    return response.json();
  } else {
    var error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

export function checkHttpStatusAuthCheck(response, dispatch, getState) {
  if (response.status >= 200 && response.status < 204) {
    return response.json();
  } else if (response.status === 204) {
    return true;
  } else if (response.status === 401) {
    localStorage.removeItem('access_token');
    localStorage.removeItem('persist:root');
    dispatch(actionCreator(loginActionTypes.logout_user.SUCCESS));
    history.push('/');
  } else if (response.status >= 400 && response.status < 500) {
    return response.json();
  } else {
    var error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

export const create_post_data = (type, data) => {
  delete data.id;
  let postData = JSON.stringify({
    data: {
      type: type,
      attributes: data,
    },
  });

  return postData;
};

// generic method for createSearchUrl
// creatd by Shiv Roy
export const createMultiSearchUrlScheduling = (urlObj, newSearchObj) => {
  let query_params = `?page[number]=${urlObj.page_number ? urlObj.page_number : 1}`;
  let x = '?include=patient,appointmenttype,appointmentstaff,patientencounter';
  if (urlObj.filters && urlObj.filters !== null) {
    let filters = urlObj.filters;
    for (const key of Object.keys(filters)) {
      query_params = query_params + `&filter[${key}]=${filters[key]}`;
    }
  }
  if (Object.values(newSearchObj) !== '') {
    let filters = newSearchObj;
    for (const key of Object.keys(filters)) {
      x += `&filter[${key}]=${filters[key]}`;
    }
  }
  // x += '&include=patient,appointmenttype,appointmentstaff,patientencounter';
  return x;
};

// generic method for createSearchUrl
// creatd by Puneet Bhandari
export const createSearchUrlScheduling = (urlObj) => {
  let query_params = `?locationIds=${urlObj.filters['locationIds'] ? urlObj.filters['locationIds'] : ''}`;
  // let x = `?page[number]=${urlObj.page_number ? urlObj.page_number : 1}`;
  if (urlObj.filters && urlObj.filters !== null) {
    let filters = urlObj.filters;
    for (const key of Object.keys(filters)) {
      if (key !== 'locationIds') {
        query_params += `&${key}=${filters[key]}`;
      }
    }
  }

  return query_params;
  /*  let query_params = `?page[number]=${urlObj.page_number ? urlObj.page_number : 1}`;
      if (urlObj.sort_fields != null) {
        query_params += `&sort=${urlObj.sort_fields}`;
      }
      if (urlObj.filters != null) {
        let filters = urlObj.filters;
        for (const key of Object.keys(filters)) {
          query_params += `&filter[${key}]=${filters[key]}`;
        }
      }
      if (urlObj.includes != null) {
        query_params += `&${urlObj.includes}`;
      }
      return query_params;*/
};


export const createSearchUrlWithoutPageNumberAndSize = (urlObj) => {
  let query_params = '';
  if (urlObj.sort_fields) {
    if (query_params === '')
      query_params += `?sort=${urlObj.sort_fields}`;
    else
      query_params += `&sort=${urlObj.sort_fields}`;
  }
  if (urlObj.filters && urlObj.filters !== null) {
    let filters = urlObj.filters;
    for (const key of Object.keys(filters)) {
      if (filters[key]) {
        if (query_params === '')
          query_params += `?filter[${key}]=${filters[key]}`;
        else
          query_params += `&filter[${key}]=${filters[key]}`;
      }
    }
  }
  if (urlObj.contain_filters && urlObj.contain_filters !== null) {
    let containfilters = urlObj.contain_filters;
    for (const key of Object.keys(containfilters)) {
      if (containfilters[key]) {
        if (query_params === '')
          query_params += `?filter[${key}]=like:${containfilters[key]}`;
        else
          query_params += `&filter[${key}]=like:${containfilters[key]}`;
      }
    }
  }
  // if (urlObj.includes != null) {
  //   query_params += `&${urlObj.includes}`;
  // }
  return query_params;
};

export const createSearchUrlEncounter = (urlObj) => {
  let query_params = `?page[number]=${urlObj.page_number ? urlObj.page_number : 1}`;
  if (urlObj.sort_fields) {
    query_params += `&sort=${urlObj.sort_fields}`;
  }
  if (urlObj.filters && urlObj.filters !== null) {
    let filters = urlObj.filters;
    for (const key of Object.keys(filters)) {
      if (filters[key])
        query_params += `&filter[${key}]=${filters[key]}`;
    }
  }
  if (urlObj.contain_filters && urlObj.contain_filters !== null) {
    let containfilters = urlObj.contain_filters;
    for (const key of Object.keys(containfilters)) {
      if (containfilters[key])
        query_params += `&filter[${key}]=like:${containfilters[key]}`;
    }
  }
  if (urlObj.includes && urlObj.includes !== null) {
    query_params += `&${urlObj.includes}`;
  }
  query_params += '&page[size]=' + GlobalVariables.PageSize ? GlobalVariables.PageSize : 10;
  return query_params;
};

export const createSearchUrl = (urlObj) => {
  let query_params = `?page[number]=${urlObj.page_number ? urlObj.page_number : 1}`;
  if (urlObj.sort_fields) {
    query_params += `&sort=${urlObj.sort_fields}`;
  }
  if (urlObj.filters && urlObj.filters !== null) {
    let filters = urlObj.filters;
    for (const key of Object.keys(filters)) {
      if (filters[key])
        query_params += `&filter[${key}]=${filters[key]}`;
    }
  }
  if (urlObj.contain_filters && urlObj.contain_filters !== null) {
    let containfilters = urlObj.contain_filters;
    for (const key of Object.keys(containfilters)) {
      if (containfilters[key])
        query_params += `&filter[${key}]=like:${containfilters[key]}`;
    }
  }
  if (urlObj.includes && urlObj.includes !== null) {
    query_params += `&${urlObj.includes}`;
  }
  query_params += `&page[size]=${urlObj.page_size ? urlObj.page_size : GlobalVariables.PageSize ? GlobalVariables.PageSize : 10}`;
  return query_params;
};

/**
 * @desc To create search object for the Custom api.
 * @param {*} urlObj
 * @todo - Please talk to Manish or your project manager before update this function.
 */
export const createSearchUrlForCustomAPI = (urlObj) => {
  let query_params = `?pageNumber=${urlObj.pageNumber ? urlObj.pageNumber : 1}`;
  query_params += `&pageSize=${urlObj.pageSize ? urlObj.pageSize : GlobalVariables.PageSize ? GlobalVariables.PageSize : 10}`;
  if (urlObj.filters && urlObj.filters !== null) {
    let filters = urlObj.filters;
    for (const key of Object.keys(filters)) {
      if (filters[key])
        query_params += `&${key}=${filters[key]}`;
    }
  }
  if (urlObj.contain_filters && urlObj.contain_filters !== null) {
    let containfilters = urlObj.contain_filters;
    for (const key of Object.keys(containfilters)) {
      if (containfilters[key] && containfilters[key] !== '')
        query_params += `&${key}=${containfilters[key]}`;
    }
  }
  if (urlObj.includes && urlObj.includes !== null) {
    query_params += `&${urlObj.includes}`;
  }

  if (urlObj.sort_fields) {
    query_params += `&sortColumn=${urlObj.sort_fields}`;
  }

  if (urlObj.sort_order) {
    query_params += `&sortOrder=${urlObj.sort_order}`;
  }

  if (urlObj.showInactiveUsersOnly) {
    query_params += `&showInactiveUsersOnly=${urlObj.showInactiveUsersOnly}`;
  }

  if (urlObj.isIncludeFutureAuthorizations != null) {
    query_params += `&isIncludeFutureAuthorizations=${urlObj.isIncludeFutureAuthorizations}`;
  }

  if (urlObj.isIncludeScheduledSessions != null) {
    query_params += `&isIncludeScheduledSessions=${urlObj.isIncludeScheduledSessions}`;
  }

  return query_params;
};

// generic method for capitalize
// creatd by Puneet Bhandari
export const capitalize = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

// generic method to calculate years based on DOB
// creatd by Puneet Bhandari
export const calculateAge = (fromdate) => {
  let todate = new Date();

  var age = [],
    fromdateNew = new Date(fromdate),
    y = [todate.getFullYear(), fromdateNew.getFullYear()],
    ydiff = y[0] - y[1],
    m = [todate.getMonth(), fromdateNew.getMonth()],
    mdiff = m[0] - m[1],
    d = [todate.getDate(), fromdateNew.getDate()],
    ddiff = d[0] - d[1];

  if (mdiff < 0 || (mdiff === 0 && ddiff < 0))--ydiff;
  if (mdiff < 0) mdiff += 12;
  if (ddiff < 0) {
    fromdateNew.setMonth(m[1] + 1, 0);
    ddiff = fromdateNew.getDate() - d[1] + d[0];
    --mdiff;
  }
  if (ydiff > 0) {
    age.push(ydiff + ' year' + (ydiff > 1 ? 's' : ' '));
    // if(mdiff> 0) age.push(mdiff+ ' month'+(mdiff> 1? 's ':' '));
  } else if (mdiff > 0) {
    age.push(mdiff + ' month' + (mdiff > 1 ? 's' : ' '));
    // if(ddiff> 0) age.push(ddiff+ ' day'+(ddiff> 1? 's ':' '));
  } else if (ddiff >= 0) {
    age.push((ddiff ? ddiff : 1) + ' day' + (ddiff > 1 ? 's' : ''));
  }
  // f(ydiff> 0) age.push(ydiff+ ' year'+(ydiff> 1? 's ':' '));
  // if(mdiff> 0) age.push(mdiff+ ' month'+(mdiff> 1? 's':''));
  // if(ddiff> 0) age.push(ddiff+ ' day'+(ddiff> 1? 's':''));
  // if(age.length>1) age.splice(age.length-1,0,' and ');
  return age.join('');
};

// generic method for format date in application
// creatd by Puneet Bhandari
export const formatDate = (date) => {
  return moment(date).format('MM/DD/YYYY');
};


// Generic method for success message
// creatd by Puneet Bhandari
export const showSuccessMessage = (message, timeout) => {
  Alert.success(message, {
    position: 'bottom-right',
    effect: 'slide',
    timeout: timeout ? timeout : 5000,
  });
};
// Generic method for error message
// creatd by Lovepreet Singh
export const showErrorMessage = (message, timeout) => {
  Alert.error(message, {
    position: 'bottom-right',
    effect: 'slide',
    timeout: timeout ? timeout : 5000,
  });
};
// Generic method for warning message
// creatd by Lovepreet Singh
export const showWarningMessage = (message, timeout) => {
  Alert.warning(message, {
    position: 'bottom-right',
    effect: 'slide',
    timeout: timeout ? timeout : 10000,
  });
};

/**
   * @function: alert Warning for user confirmation
   * @param {string}: message to show
   * @param {object}: configurations to apply
   * @description: show customButtons or defaultButton for confirmation
   */
export const alertConfirmation = (message, configObj) => {
  // set default config...
  let alertConfigurations = {
    position: 'bottom-right',
    effect: 'slide',
    timeout: 10000,
  };
  if (configObj) {
    let { customButtons, ...props } = configObj;
    let customFields = {};
    if (customButtons) {
      customFields = {
        displayComponent: true,
        customButtons: customButtons,
      };
    }
    alertConfigurations = {
      customFields,
      ...alertConfigurations,
      ...props,
    };
  }
  Alert.closeAll();
  Alert.warning(message, alertConfigurations);
};

// Generic method for to extract included data based on type and id
// creatd by Puneet Bhandari
export function extractDataFromObject(type, myArray, id) {
  // let returnArr = [];
  if (myArray) {
    for (var i = 0; i < myArray.length; i++) {
      if (myArray[i].type === type && parseInt(myArray[i].id, 10) === parseInt(id, 10)) {
        return myArray[i].attributes;
      }
    }
  }
}
// Generic method for to extract included  simillar-type-data based on type
// created by Lovepreet
export function extractTypeFromObject(type, myArray) {
  let returnArr = [];
  if (myArray) {
    for (var i = 0; i < myArray.length; i++) {
      if (myArray[i].type === type) {
        returnArr.push(myArray[i]);
      }
    }
    return returnArr;
  }
}
// Generic method for to extract name based on id
// created by Lovepreet
export function extractNameFromArray(myArray, id) {
  let returnName = '';
  if (myArray) {
    for (var i = 0; i < myArray.length; i++) {
      if (parseInt(myArray[i].id, 10) === parseInt(id, 10)) {
        returnName = myArray[i].value;
      }
    }
    return returnName;
  }
};

// // Generic method for to extract array of ID and Value
// export function extractSelectedDataFromArray(masterArray, myArray) {
//   let returnArray = [];
//   if (masterArray != undefined && myArray != undefined) {
//     for (var i = 0; i < myArray.length; i++) {
//       for (var j = 0; j < masterArray.length; j++) {
//         if (parseInt(myArray[i].id, 10) === parseInt(masterArray[j].id, 10)) {
//           let obj = {
//             'id': masterArray[j].id,
//             'value': masterArray[j].value,
//           };
//           returnArray.push(obj);
//           break;
//         }
//       }
//     }
//     return returnArray;
//   }
// };
// Generic method for to extract all attributes of an object based on id
// created by Lovepreet
export function extractDataFromArray(myArray, id) {
  let returnobj = {};
  if (myArray) {
    for (var i = 0; i < myArray.length; i++) {
      if (parseInt(myArray[i].id, 10) === parseInt(id, 10)) {
        returnobj = myArray[i];
      }
    }
    return returnobj;
  }
};

export function extractDataFromArrayByValue(myArray, value, isCountry) {

  let returnobj = {};
  if (myArray) {
    for (var i = 0; i < myArray.length; i++) {
      if (isCountry) {
        if (myArray[i].value.toUpperCase() === value.toUpperCase()) {
          returnobj = myArray[i];
        }
      } else {
        if (myArray[i].value.toUpperCase() === value.toUpperCase() || myArray[i].stateAbbr.toUpperCase() === value.toUpperCase()) {
          returnobj = myArray[i];
        }
      }
    }
    return returnobj;
  }
};

/**
 * [handleRefreshTokenRedirect - on page refresh redirect to current page]
 * @param {*} token
 * @param {*} authData
 */
export function handleRefreshTokenRedirect(token, urlPath) {
  localStorage.setItem('access_token', token);
  history.push(urlPath);
}

/**
 * [handleLoginRedirect - on login redirect to dashboard page]
 * @param  {[type]} token [description]
 * @return {[type]}       [description]
 */
export function handleLoginRedirect(token, authData, targetUrl) {
  localStorage.setItem('access_token', token);
  history.push(targetUrl);
}
/**
 * [handleFirstLoginAfterSignUp - a method built that will redirect to 1 secuirty question on every login until the machine is new or local storage is empty]
 *
 * @param {*} response
 * @param {*} authData
 */
export function handleFirstLoginAfterSignUp(response, authData) {
  history.push({ pathname: '/question', state: { response: response, authData: authData } });
}

/**
 *  [handleSecurityQuestionRedirect - a method built that will redirect to 3 secuirty questions on first login after signup]
 * @param {*} response
 * @param {*} authData
 */

export function handleSecurityQuestionRedirect(response, authData) {
  // debugger
  history.push({ pathname: '/security-questions', state: { response: response, authData: authData } });
}


/**
 * [handleLogoutRedirect - on logout redirect to login page]
 * @return {[type]} [description]
 */
export function handleLogoutRedirect(targetUrl) {
  localStorage.removeItem('access_token');
  history.push(targetUrl);
}

/**
 * [parseJSON - parse JSON value]
 * @param  {[type]} response [description]
 * @return {[type]}          [description]
 */
export function parseJSON(response) {
  return response.data;
}
// created by lovepreet singh
// please everyone display date on view using this function.
export function showFormatedDate(date) {
  // return moment(date).format('MMM DD, YYYY');
  return moment(date).format('MM/DD/YYYY');
}

// created by abhishek
// please everyone display date on view using this function.
export function showFormatedDateandTimeForSessionLogs(date) {
  return moment(date).format('MM/DD/YYYY') + ' at ' + moment(date).format('hh:mm a');
}
export function showFormatedDateandTime(date) {
  return moment(date).format('MM/DD/YYYY hh:mm a');
}
export function showFormatedDateandTimewithsec(date) {
  return moment(date).format('MM/DD/YYYY hh:mm:ss a');
}
export function calculateLocalTimeZone() {
  let TZ = /\((.*)\)/.exec(new Date().toString());
  let TimeZone = '';
  if (TZ.length > 0)
    TimeZone = TZ[1];
  return TimeZone;
}

export function resetFiltersAndSorting(filter, sortColumn, isCustomFilter) {

  if (isCustomFilter) {
    filter.sort_Column = sortColumn;
    filter.sort_Order = 'desc';
  } else {
    filter.sort_Column = '-' + sortColumn;
  }

  filter.searchText = '';
  // Reset Sorting
  let TblSort = document.getElementsByClassName('Tblsort');
  for (let i = 0; i < TblSort.length; i++) {
    TblSort[i].className = 'Tblsort sorting';
  }
}
/**
 * created by Lovepreet singh
 * date: 18-12-2017
 * standard method designed to display rate in proper format
 */
export function showNormalizedRate(rate) {
  let onlyNumRate = '';
  let indexOfDot = rate.toString().indexOf('.');
  if (indexOfDot !== -1) {
    if (indexOfDot === 0) {
      onlyNumRate = rate.toString().slice(1);
    } else {
      onlyNumRate = rate.toString().slice(0, indexOfDot) + rate.toString().slice(indexOfDot + 1);
    }
  } else onlyNumRate = rate.toString();
  if (onlyNumRate.length > 0) {
    if (onlyNumRate.length === 1) {
      return '0' + onlyNumRate + '.00';
    } else if (onlyNumRate.length === 2) {
      if (indexOfDot !== -1) {
        return '0' + onlyNumRate[0] + '.' + onlyNumRate[1] + '0';
      } else {
        return onlyNumRate + '.00';
      }
    } else if (onlyNumRate.length === 3) {
      if (indexOfDot === onlyNumRate.length - 1) {
        return onlyNumRate.slice(0, 2) + '.' + onlyNumRate.slice(2) + '0';
      } else if (indexOfDot !== -1) {
        return '0' + onlyNumRate.slice(0, 1) + '.' + onlyNumRate.slice(1);
      } else {
        return onlyNumRate + '.00';
      }

    } else if (onlyNumRate.length === 4) {
      if (indexOfDot !== -1) {
        if (indexOfDot === 3)
          return onlyNumRate.slice(0, indexOfDot) + '.' + onlyNumRate.slice(indexOfDot) + '0';
        else
          return onlyNumRate.slice(0, indexOfDot) + '.' + onlyNumRate.slice(indexOfDot);
      } else {
        return onlyNumRate + '.00';
      }

    } else if (onlyNumRate.length > 4) {
      if (indexOfDot !== -1) {
        if (indexOfDot === onlyNumRate.length - 1) {
          return onlyNumRate.slice(0, indexOfDot) + '.' + onlyNumRate.slice(indexOfDot) + '0';
        } else
          return onlyNumRate.slice(0, indexOfDot) + '.' + onlyNumRate.slice(indexOfDot);
      } else {
        return onlyNumRate + '.00';
      }

    }
  } else {
    return onlyNumRate;
  }
}

// show the time from new Date function.
export function showFormattedTime(dateTime) {
  let timeNow = new Date(dateTime),
    hours = timeNow.getHours(),
    minutes = timeNow.getMinutes();
    // seconds = timeNow.getSeconds();
  let timeString = '' + ((hours > 12) ? hours - 12 : hours);
  timeString += ((minutes < 10) ? ':0' : ':') + minutes;
  // timeString += ((seconds < 10) ? ':0' : ':') + seconds;
  timeString += (hours >= 12) ? ' PM' : ' AM';
  return timeString;
}

export function currencyFormat(num) {
  return '$' + num.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

/**
 * @todo subdomain redirection according to url
 * @desc window.location.host is subdomain.domain.com
 */
export function subDomainUrlRedirection() {
  let full = window.location.host;
  let subdomain = null;

  // Development environment checks  
  const devEnvironments = [
    'localhost:3000',
    '104.238.100.164:5000',
    '10.138.0.163',
    '10.138.0.154:8080',
    '10.138.0.154:9090', 
    '35.197.20.253',
    'staging.theralytics.net',
    'stagingqa.theralytics.net',
    'development.theralytics.net',
  ];

  if (devEnvironments.includes(full)) {
    full = process.env.REACT_APP_SUBDOMAIN + '.theralytics.net';
  }

  // Admin portal checks
  if (full === 'webadmin.theralytics.net' || 
      full === 'manage.theralytics.net' ||
      full === 'theralytics.net/login' || 
      full === 'theralytics.net/client-login') {
    history.push('/webadmin/login');
    return null;
  }

  // Handle QA environment URLs
  if (full.includes('.qa.theralytics.net')) {
    const parts = full.split('.');
    if (parts.length > 4) {
      subdomain = parts[0]; // Get business name e.g. 'vip' from vip.qa1.qa.theralytics.net --- Not supported yet
      return subdomain;
    } else {
      return process.env.REACT_APP_SUBDOMAIN;
    }
  }
  
  // Handle legacy and production URLs
  const parts = full.split('.');
  const isSubdomainEnv = full === process.env.REACT_APP_SUBDOMAIN + '.theralytics.net';
  
  if ((isSubdomainEnv && parts.length >= 2) || (!isSubdomainEnv && parts.length > 2)) {
    subdomain = parts[0];
  }

  return subdomain;
}

/**
 * @desc To download any file(like pdf, word, xls, image etc) on api call
 * @param {*} blob
 */
export const downloadFilesOnAPICall = (blob, claimId) => {
  // It is necessary to create a new blob object with mime-type explicitly set
  // otherwise only Chrome works like it should
  var newBlob = new Blob([blob], { type: 'application/pdf' });
  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
    return;
  }
  // For other browsers:
  // Create a link pointing to the ObjectURL containing the blob.
  const data = window.URL.createObjectURL(newBlob);
  var link = document.createElement('a');
  document.body.appendChild(link);
  link.href = data;
  link.download = `CL${claimId}_PaperClaim`;
  // link.download = 'form1500.pdf';
  link.click();
  setTimeout(function() {
    // For Firefox it is necessary to delay revoking the ObjectURL
    document.body.removeChild(link);
    window.URL.revokeObjectURL(data);
  }, 100);
};

/**
 * @desc To download any file(like pdf, word, xls, image etc) on api call
 * @param {*} blob
 */
export const downloadFilesOnAPICallForCCDA = (blob) => {
  // It is necessary to create a new blob object with mime-type explicitly set
  // otherwise only Chrome works like it should
  var newBlob = new Blob([blob], { type: 'application/xml' });
  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
    return;
  }
  // For other browsers:
  // Create a link pointing to the ObjectURL containing the blob.
  const data = window.URL.createObjectURL(newBlob);
  var link = document.createElement('a');
  link.href = data;
  link.download = 'CCDA.zip';
  link.click();
  setTimeout(function() {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data);
  }, 100);
};

export const downloadFilesOnAPICallForEDI = (blob) => {
  // It is necessary to create a new blob object with mime-type explicitly set
  // otherwise only Chrome works like it should
  var newBlob = new Blob([blob], { type: 'text/plain' });
  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
    return;
  }
  // For other browsers:
  // Create a link pointing to the ObjectURL containing the blob.
  const data = window.URL.createObjectURL(newBlob);
  var link = document.createElement('a');
  document.body.appendChild(link);
  link.href = data;
  link.download = 'EDI_837.X12';
  link.click();
  setTimeout(function() {
    // For Firefox it is necessary to delay revoking the ObjectURL
    document.body.removeChild(link);
    window.URL.revokeObjectURL(data);
  }, 100);
};

/**
 * @desc To download any file(like pdf, word, xls, image etc) on api call for uploaded document
 * @param {*} blob
 */
export const downloaduploadedDocumentsOnAPICall = (blob, fileName) => {
  // let type = blob.type.split('/').pop().toLowerCase();
  // let file = fileName;
  var newBlob = new Blob([blob], { type: `${blob.type}` });
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
    return;
  }
  const data = window.URL.createObjectURL(newBlob);
  var link = document.createElement('a');
  document.body.appendChild(link);
  link.href = data;
  link.download = fileName;
  link.click();
  setTimeout(function() {
    document.body.removeChild(link);
    window.URL.revokeObjectURL(data);
  }, 100);
};


/**
 * @desc To Preview any file(like pdf, word, xls, image etc) on api call for uploaded document
 * @param {*} blob
 */
export const PreviewUploadedDocumentsOnAPICall = (blob, fileName) => {
  // let type = blob.type.split('/').pop().toLowerCase();
  // let file = fileName;
  var newBlob = new Blob([blob], { type: `${blob.type}` });
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
    return;
  }
  const data = window.URL.createObjectURL(newBlob);
  var link = document.createElement('a');
  document.body.appendChild(link);
  link.href = data;
  link.preview = fileName;
  window.open(link, '_blank');
  // link.click();
  setTimeout(function() {
    document.body.removeChild(link);
    window.URL.revokeObjectURL(data);
  }, 100);
};

/**
 * @desc To encode url ids
 * @param {id encode} text
 */
export const base64Encode = (text) => {
  let bytes = utf8.encode(text);
  let encoded = base64.encode(bytes);
  return encoded;
};

/**
 * @desc To  url ids
 * @param {id decode} encoded
 */
export const base64Decode = (encoded) => {
  let bytes = base64.decode(encoded);
  let text = utf8.decode(bytes);
  return text;
};


// export const base64Encode = (text) => {
//   // let bytes = utf8.encode(text);
//   // let encoded = base64.encode(bytes);
//   // return encoded;
//   return text;
// };

// /**
//  * @desc To  url ids
//  * @param {id decode} encoded
//  */
// export const base64Decode = (encoded) => {
//   // let bytes = base64.decode(encoded);
//   // let text = utf8.decode(bytes);
//   // return text;
//   return encoded;
// };

export function svgToPng(svgText, margin, fill) {
  // convert an svg text to png using the browser
  return new Promise(function(resolve, reject) {
    try {
      // can use the domUrl function from the browser
      var domUrl = window.URL || window.webkitURL || window;
      if (!domUrl) {
        throw new Error('(browser doesnt support this)');
      }
      // figure out the height and width from svg text
      var match = svgText.match(/height=\"(\d+)/m);
      var height = match && match[1] ? parseInt(match[1], 10) : 200;
      var match = svgText.match(/width=\"(\d+)/m);
      var width = match && match[1] ? parseInt(match[1], 10) : 200;
      margin = margin || 0;

      // it needs a namespace
      if (!svgText.match(/xmlns=\"/mi)) {
        svgText = svgText.replace('<svg ', '<svg xmlns="http://www.w3.org/2000/svg" ');
      }

      // create a canvas element to pass through
      var canvas = document.createElement('canvas');
      canvas.width = width + margin * 4;
      canvas.height = height + margin * 2;
      var ctx = canvas.getContext('2d');

      // make a blob from the svg
      var svg = new Blob([svgText], {
        type: 'image/svg+xml;charset=utf-8',
      });

      // create a dom object for that image
      var url = domUrl.createObjectURL(svg);

      // create a new image to hold it the converted type
      var img = new Image;

      // when the image is loaded we can get it as base64 url
      img.onload = function() {
        // draw it to the canvas
        ctx.drawImage(this, margin, margin);
        // if it needs some styling, we need a new canvas
        if (fill) {
          var styled = document.createElement('canvas');
          styled.width = canvas.width;
          styled.height = canvas.height;
          var styledCtx = styled.getContext('2d');
          styledCtx.save();
          styledCtx.fillStyle = fill;
          styledCtx.fillRect(0, 0, canvas.width, canvas.height);
          styledCtx.strokeRect(0, 0, canvas.width, canvas.height);
          styledCtx.restore();
          styledCtx.drawImage(canvas, 0, 0);
          canvas = styled;
        }
        // we don't need the original any more
        domUrl.revokeObjectURL(url);
        // now we can resolve the promise, passing the base64 url
        resolve(canvas.toDataURL());
      };

      // load the image
      img.src = url;

    } catch (err) {
      reject('failed to convert svg to png ' + err);
    }
  });
}

export function getSVG(charts) {
  var svgArr = [],
    top = 0,
    width = 0;

  charts.forEach((chart) => {
    var svg = chart.getSVG();
    svg = svg.replace('<svg', '<g transform="translate(0,' + top + ')" ');
    svg = svg.replace('</svg>', '</g>');

    top += chart.chartHeight;
    width = Math.max(width, chart.chartWidth);

    svgArr.push(svg);
  });
  return '<svg height="' + top + '" width="' + width + '" version="1.1" xmlns="http://www.w3.org/2000/svg">' + svgArr.join('') + '</svg>';
}


export function isArrayEquals(array1, array2) {
  if (array1 === array2) return true;
  if (array1 == null || array2 == null) return false;
  if (array1.length !== array2.length) return false;

  let tempArray = [];
  array1.forEach((e1) => {
    array2.forEach((e2) => {
      if (e1 === e2)
        tempArray.push(e1);
    });
  });

  return (tempArray.length === array1.length);
}

export function getLinearRegression(xData, yData) {
  var sumX = 0,
    sumY = 0,
    sumXY = 0,
    sumX2 = 0,
    linearData = [],
    linearXData = [],
    linearYData = [],
    n = xData.length,
    alpha, beta, i, x, y;

  // Get sums:
  for (i = 0; i < n; i++) {
    x = xData[i];
    y = yData[i];
    sumX += x;
    sumY += y;
    sumXY += x * y;
    sumX2 += x * x;
  }

  // Get slope and offset:
  alpha = (n * sumXY - sumX * sumY) / (n * sumX2 - sumX * sumX);
  if (isNaN(alpha)) {
    alpha = 0;
  }
  beta = (sumY - alpha * sumX) / n;

  // Calculate linear regression:
  for (i = 0; i < n; i++) {
    x = xData[i];
    y = alpha * x + beta;

    // Prepare arrays required for getValues() method
    linearData[i] = [x, y];
    linearXData[i] = x;
    linearYData[i] = y;
  }

  return {
    xData: linearXData,
    yData: linearYData,
    values: linearData,
  };
}

/**
 * @desc To  url ids
 * @param {id decode} encoded
 */
export const GetReportUrl = (agencyName) => {

  let reportUrl = 'https://reports.theralytics.net/Report.aspx';

  // || agencyName.toUpperCase() === 'NORTHSTAR'
  // if(agencyName.toUpperCase() === 'HIPAAAUDIT' || agencyName.toUpperCase() === 'BLUEBIRDBEHAVIORAL' || agencyName.toUpperCase() === 'GOLDENFLOWERNW' || agencyName.toUpperCase() === 'PLATINUM'
  //  || agencyName.toUpperCase() === 'COLLABOTHERAPIES' || agencyName.toUpperCase() === 'CWABA' || agencyName.toUpperCase() === 'ABCABA' || agencyName.toUpperCase() === 'UPSTATEABA'
  // || agencyName.toUpperCase() === 'SEEDLINGSABA' || agencyName.toUpperCase() === 'SPECTRUMTLC' || agencyName.toUpperCase() === 'HEARTANDSOULABA'
  // || agencyName.toUpperCase() === 'UPLUS' || agencyName.toUpperCase() === 'ALC' || agencyName.toUpperCase() === 'DEMO' || agencyName.toUpperCase() === 'NOVA' || agencyName.toUpperCase() === 'NEABA' || agencyName.toUpperCase() === 'BESTABA'
  // || agencyName.toUpperCase() === 'BEHAVIORBLOSSOMS' || agencyName.toUpperCase() === 'EBS' || agencyName.toUpperCase() === 'ABAUNLIMITED' || agencyName.toUpperCase() === 'BUILDABLOCKTHERAPY' || agencyName.toUpperCase() === 'SWANCONSULTINGINC'
  // || agencyName.toUpperCase() === 'INSIGHTSABA' || agencyName.toUpperCase() === 'ABC' || agencyName.toUpperCase() === 'IAT' || agencyName.toUpperCase() === 'ART' || agencyName.toUpperCase() === 'LITTLELEMONS'
  // || agencyName.toUpperCase() === 'CREATIVETHERAPY' || agencyName.toUpperCase() === 'TEXASABACDS' || agencyName.toUpperCase() === 'POSITIVEBEHAVIORSTEPS' || agencyName.toUpperCase() === 'VILLAGELEARNING' || agencyName.toUpperCase() === 'PACE'
  // || agencyName.toUpperCase() === 'TRAC' || agencyName.toUpperCase() === 'HYPERIONCENTER' || agencyName.toUpperCase() === 'CLINICALB' || agencyName.toUpperCase() === 'HELPINGHANDS' || agencyName.toUpperCase() === 'CBF'
  // || agencyName.toUpperCase() === 'ABCWVVA' || agencyName.toUpperCase() === 'ARROWS' || agencyName.toUpperCase() === 'EARLYBIRDSABA' || agencyName.toUpperCase() === 'CBG' || agencyName.toUpperCase() === 'PBSMIDWEST')
  // {
  //   reportUrl = 'https://cloudreports.theralytics.net/Report.aspx';
  // }
  // else
  // {
  //   reportUrl = 'https://reports.theralytics.net/Report.aspx';
  // }

  return reportUrl;
};


export function getAge(dateString) {
  var now = new Date();
  var today = new Date(now.getYear(), now.getMonth(), now.getDate());

  var yearNow = now.getYear();
  var monthNow = now.getMonth();
  var dateNow = now.getDate();

  var dob = new Date(dateString.substring(6, 10),
    dateString.substring(0, 2) - 1,
    dateString.substring(3, 5)
  );

  var yearDob = dob.getYear();
  var monthDob = dob.getMonth();
  var dateDob = dob.getDate();
  var age = {};
  var ageString = '';
  var yearString = '';
  var monthString = '';
  var dayString = '';


  let yearAge = yearNow - yearDob;

  if (monthNow >= monthDob)
    var monthAge = monthNow - monthDob;
  else {
    yearAge--;
    var monthAge = 12 + monthNow - monthDob;
  }

  if (dateNow >= dateDob)
    var dateAge = dateNow - dateDob;
  else {
    monthAge--;
    var dateAge = 31 + dateNow - dateDob;

    if (monthAge < 0) {
      monthAge = 11;
      yearAge--;
    }
  }

  age = {
    years: yearAge,
    months: monthAge,
    days: dateAge,
  };

  // if ( age.years > 1 ) yearString = " years";
  // else yearString = " year";
  // if ( age.months> 1 ) monthString = " months";
  // else monthString = " month";
  // if ( age.days > 1 ) dayString = " days";
  // else dayString = " day";

  if (age.years > 1) yearString = ' y';
  else yearString = ' y';
  if (age.months > 1) monthString = ' m';
  else monthString = ' m';
  if (age.days > 1) dayString = ' d';
  else dayString = ' d';


  if ((age.years > 0) && (age.months > 0) && (age.days > 0))
    ageString = age.years + yearString + ', ' + age.months + monthString + ', ' + age.days + dayString;
  else if ((age.years == 0) && (age.months == 0) && (age.days > 0))
    ageString = 'Only ' + age.days + dayString;
  else if ((age.years > 0) && (age.months == 0) && (age.days == 0))
    ageString = age.years + yearString;
  else if ((age.years > 0) && (age.months > 0) && (age.days == 0))
    ageString = age.years + yearString + ' , ' + age.months + monthString;
  else if ((age.years == 0) && (age.months > 0) && (age.days > 0))
    ageString = age.months + monthString + ' , ' + age.days + dayString;
  else if ((age.years > 0) && (age.months == 0) && (age.days > 0))
    ageString = age.years + yearString + ' , ' + age.days + dayString;
  else if ((age.years == 0) && (age.months > 0) && (age.days == 0))
    ageString = age.months + monthString;
  else ageString = 'Oops! Could not calculate age!';

  // if ( (age.years > 0) && (age.months > 0) && (age.days > 0) )
  //   ageString = age.years + yearString + ", " + age.months + monthString;
  // else if ( (age.years == 0) && (age.months == 0) && (age.days > 0) )
  //   ageString = "Only " + age.days + dayString ;
  // else if ( (age.years > 0) && (age.months == 0) && (age.days == 0) )
  //   ageString = age.years + yearString;
  // else if ( (age.years > 0) && (age.months > 0) && (age.days == 0) )
  //   ageString = age.years + yearString + ", " + age.months + monthString ;
  // else if ( (age.years == 0) && (age.months > 0) && (age.days > 0) )
  //   ageString = age.months + monthString;
  // else if ( (age.years > 0) && (age.months == 0) && (age.days > 0) )
  //   ageString = age.years + yearString ;
  // else if ( (age.years == 0) && (age.months > 0) && (age.days == 0) )
  //   ageString = age.months + monthString;
  // else ageString = "Oops! Could not calculate age!";

  return ageString;
}



// WEBPACK FOOTER //
// ./src/actions/utilAction.js